import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { SubReservationApiModel } from '@rocksoft/inroom-sdk';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectCurrentMobileReservation } from '../../../stores/mobilereservation/mobilereservation.selector';
import { GuestInfoContainerComponent } from '../guest-info/guest-info.container';

@Component({
  selector: 'era-guest-dropdown',
  templateUrl: './guest-dropdown.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, GuestInfoContainerComponent, AsyncPipe],
})
export class GuestDropdownContainerComponent {
  private readonly store = inject(Store);

  public readonly reservation$: Observable<SubReservationApiModel | undefined>;

  constructor() {
    this.reservation$ = this.store.select(selectCurrentMobileReservation).pipe(map((x) => x?.SubReservations?.[0]));
  }
}
